import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { StatusNotificationItem } from './Item'

const StatusNotifications = ({
  title,
  ids,
  addBottomSpacing,
  screenType,
  timeType,
}) => {
  return (
    <div
      className="flexColumn justifyContentBetween"
      style={{
        rowGap: `12px`,
        paddingBottom: addBottomSpacing ? '12px' : 0,
      }}
    >
      <Element
        style={{
          fontSize: 14,
          fontWeight: 600,
          color: '#3A414B',
        }}
      >
        <Translate value={title} />
      </Element>
      <Element
        className="flexColumn justifyContentBetween"
        style={{
          rowGap: `12px`,
          paddingRight: `12px`,
        }}
      >
        {ids.map((item, index) => (
          <StatusNotificationItem
            key={item}
            id={item}
            isLastIndex={index === ids.length - 1}
            screenType={screenType}
            timeType={timeType}
          />
        ))}
      </Element>
    </div>
  )
}

StatusNotifications.propTypes = {
  title: PropTypes.string.isRequired,
  ids: PropTypes.array.isRequired,
  addBottomSpacing: PropTypes.bool,
  screenType: PropTypes.string.isRequired,
  timeType: PropTypes.string.isRequired,
}

export default StatusNotifications
